import type { FormDrawerProps } from '../../FormDrawer';
import { XeroConfigurationForm } from './components/XeroConfigurationForm';
import { XeroConfigurationFormSchema } from './XeroConfigurationFormSchema';
import { XeroConfigurationFooter } from './components/XeroConfigurationFooter';

export const ConfigureXeroComponents: FormDrawerProps = {
  zodSchema: XeroConfigurationFormSchema,
  ContentComponent: XeroConfigurationForm,
  Footer: XeroConfigurationFooter,
};
